/**
 * i18n.js — Vertalingen NL / EN
 * Gebruik via useLang() hook (zie LangContext.jsx)
 */

const translations = {
  nl: {
    // Navigatie
    nav_dashboard:    'Dashboard',
    nav_connections:  'Aansluitingen',
    nav_invoices:     'Facturen',
    nav_analytics:    'Analyse',
    nav_users:        'Gebruikers',
    nav_logout:       'Afmelden',
    app_subtitle:     'Energiefacturen',

    // Auth
    login_email:      'E-mailadres',
    login_password:   'Wachtwoord',
    login_submit:     'Aanmelden',
    login_error:      'Ongeldige inloggegevens',

    // Algemeen
    loading:          'Laden...',
    save:             'Opslaan',
    cancel:           'Annuleren',
    edit:             'Bewerken',
    delete:           'Verwijderen',
    error:            'Er ging iets mis',
    back:             'Terug',
    all:              'Alle',
    no_data:          'Nog geen gegevens',
    confirm_delete:   'Zeker verwijderen?',

    // Energietype / meter
    type_elektriciteit: 'Elektriciteit',
    type_gas:           'Gas',
    meter_enkelvoudig:  'Enkelvoudig',
    meter_tweevoudig:   'Tweevoudig (dag/nacht)',
    meter_digitaal:     'Digitaal',

    // Dashboard
    dash_title:          'Dashboard',
    kpi_consumption_year:'Verbruik dit jaar',
    kpi_cost_year:       'Kost dit jaar',
    kpi_avg_price:       'Gem. eenheidsprijs',
    kpi_invoices:        'Facturen',
    vs_last_year:        't.o.v. vorig jaar',
    chart_monthly_consumption: 'Verbruik per maand',
    chart_monthly_cost:  'Kost per maand',
    chart_unit_price:    'Evolutie eenheidsprijs',

    // Aansluitingen
    connections_title: 'Aansluitingen',
    conn_new:          'Nieuwe aansluiting',
    conn_label:        'Label',
    conn_ean:          'EAN-code',
    conn_type:         'Energietype',
    conn_address:      'Adres',
    conn_meter:        'Metertype',
    conn_solar:        'Zonnepanelen',
    conn_supplier:     'Leverancier',
    conn_notes:        'Notities',
    conn_invoices:     'Facturen',
    conn_last_period:  'Laatste periode',

    // Facturen
    invoices_title:    'Facturen',
    inv_new:           'Handmatig invoeren',
    inv_upload:        'PDF uploaden',
    inv_connection:    'Aansluiting',
    inv_number:        'Factuurnummer',
    inv_type:          'Type',
    inv_date:          'Factuurdatum',
    inv_period:        'Periode',
    inv_period_start:  'Periode van',
    inv_period_end:    'Periode tot',
    inv_consumption:   'Verbruik',
    inv_amount:        'Bedrag (incl. btw)',
    inv_status:        'Status',
    inv_filter_year:   'Jaar',
    inv_filter_type:   'Energietype',
    inv_export:        'Excel-export',

    // Factuurtypes
    itype_afrekening:    'Afrekening',
    itype_tussentijds:   'Tussentijds',
    itype_voorschot:     'Voorschot',
    itype_jaarafrekening:'Jaarafrekening',

    // Parse-status
    pstatus_parsed:    'Geparsed',
    pstatus_manual:    'Handmatig',
    pstatus_verified:  'Bevestigd',

    // Upload
    upload_title:      'Factuur uploaden',
    upload_choose:     'Kies een Engie-PDF',
    upload_parsing:    'PDF wordt gelezen...',
    upload_preview:    'Controleer en corrigeer de gegevens',
    upload_method:     'Methode',
    upload_confidence: 'Betrouwbaarheid',
    upload_hint:       'De velden zijn automatisch ingevuld. Controleer ze en pas aan waar nodig vóór je bevestigt.',

    // Factuurformulier
    f_consumption_total: 'Totaal verbruik',
    f_gas_m3:            'Gasverbruik (m³)',
    f_gas_kwh:           'Gasverbruik (kWh)',
    f_factor:            'Omrekenfactor (kWh/m³)',
    f_consumption_day:   'Dagverbruik (kWh)',
    f_consumption_night: 'Nachtverbruik (kWh)',
    f_injection:         'Injectie zonnepanelen (kWh)',
    f_peak_power:        'Piekvermogen / capaciteit (kW)',
    f_amount_energy:     'Energiekost (€)',
    f_amount_network:    'Netkosten (€)',
    f_amount_taxes:      'Heffingen (€)',
    f_amount_excl:       'Totaal excl. btw (€)',
    f_vat:               'Btw (€)',
    f_amount_incl:       'Totaal incl. btw (€)',
    f_notes:             'Notities',
    save_invoice:        'Factuur opslaan',

    // Lijnopbouw
    lines_title:   'Detailopbouw',
    lines_hint:    'Elke lijn van de factuur. Het totaal excl. btw wordt automatisch berekend uit de bedragen.',
    line_add:      'Lijn toevoegen',
    col_group:     'Groep',
    col_desc:      'Omschrijving',
    col_qty:       'Hoeveelheid',
    col_price:     'Eenheidsprijs',
    col_amount:    'Bedrag (€)',
    group_afname:        'Afname',
    group_injectie:      'Injectie',
    group_groene_stroom: 'Groene stroom',
    group_wkk:           'WKK',
    group_netwerk:       'Netwerk',
    group_toeslagen:     'Toeslagen',
    group_andere:        'Andere',

    // Gebruikers
    user_new:          'Nieuwe gebruiker',
    user_name:         'Naam',
    user_email:        'E-mail',
    user_role:         'Rol',
    user_active:       'Actief',
    user_inactive:     'Inactief',
    user_password:     'Wachtwoord',
    user_password_hint:'leeg laten om niet te wijzigen',
    role_admin:        'Beheerder',
    role_viewer:       'Lezer',

    // Analyse
    analytics_title:   'Analyse',
    an_consumption:    'Verbruik',
    an_costs:          'Kosten (energie / net / heffingen)',
    an_unit_price:     'Eenheidsprijs',
    an_comparison:     'Jaarvergelijking',
    an_components:     'Kosten per component',
    an_unit_detail:    'Eenheidsprijs piek / dal',
    an_injection:      'Afname vs injectie',
    metric_kwh:        'Verbruik (kWh)',
    metric_eur:        'Bedrag (€)',
  },

  en: {
    nav_dashboard:    'Dashboard',
    nav_connections:  'Connections',
    nav_invoices:     'Invoices',
    nav_analytics:    'Analytics',
    nav_users:        'Users',
    nav_logout:       'Log out',
    app_subtitle:     'Energy invoices',

    login_email:      'Email',
    login_password:   'Password',
    login_submit:     'Sign in',
    login_error:      'Invalid credentials',

    loading:          'Loading...',
    save:             'Save',
    cancel:           'Cancel',
    edit:             'Edit',
    delete:           'Delete',
    error:            'Something went wrong',
    back:             'Back',
    all:              'All',
    no_data:          'No data yet',
    confirm_delete:   'Delete for sure?',

    type_elektriciteit: 'Electricity',
    type_gas:           'Gas',
    meter_enkelvoudig:  'Single',
    meter_tweevoudig:   'Dual (day/night)',
    meter_digitaal:     'Digital',

    dash_title:          'Dashboard',
    kpi_consumption_year:'Consumption this year',
    kpi_cost_year:       'Cost this year',
    kpi_avg_price:       'Avg. unit price',
    kpi_invoices:        'Invoices',
    vs_last_year:        'vs last year',
    chart_monthly_consumption: 'Consumption per month',
    chart_monthly_cost:  'Cost per month',
    chart_unit_price:    'Unit price trend',

    connections_title: 'Connections',
    conn_new:          'New connection',
    conn_label:        'Label',
    conn_ean:          'EAN code',
    conn_type:         'Energy type',
    conn_address:      'Address',
    conn_meter:        'Meter type',
    conn_solar:        'Solar panels',
    conn_supplier:     'Supplier',
    conn_notes:        'Notes',
    conn_invoices:     'Invoices',
    conn_last_period:  'Last period',

    invoices_title:    'Invoices',
    inv_new:           'Enter manually',
    inv_upload:        'Upload PDF',
    inv_connection:    'Connection',
    inv_number:        'Invoice number',
    inv_type:          'Type',
    inv_date:          'Invoice date',
    inv_period:        'Period',
    inv_period_start:  'Period from',
    inv_period_end:    'Period to',
    inv_consumption:   'Consumption',
    inv_amount:        'Amount (incl. VAT)',
    inv_status:        'Status',
    inv_filter_year:   'Year',
    inv_filter_type:   'Energy type',
    inv_export:        'Excel export',

    itype_afrekening:    'Settlement',
    itype_tussentijds:   'Interim',
    itype_voorschot:     'Advance',
    itype_jaarafrekening:'Annual settlement',

    pstatus_parsed:    'Parsed',
    pstatus_manual:    'Manual',
    pstatus_verified:  'Confirmed',

    upload_title:      'Upload invoice',
    upload_choose:     'Choose an Engie PDF',
    upload_parsing:    'Reading PDF...',
    upload_preview:    'Check and correct the data',
    upload_method:     'Method',
    upload_confidence: 'Confidence',
    upload_hint:       'Fields are pre-filled automatically. Check and adjust them before confirming.',

    f_consumption_total: 'Total consumption',
    f_gas_m3:            'Gas consumption (m³)',
    f_gas_kwh:           'Gas consumption (kWh)',
    f_factor:            'Conversion factor (kWh/m³)',
    f_consumption_day:   'Day consumption (kWh)',
    f_consumption_night: 'Night consumption (kWh)',
    f_injection:         'Solar injection (kWh)',
    f_peak_power:        'Peak power / capacity (kW)',
    f_amount_energy:     'Energy cost (€)',
    f_amount_network:    'Network cost (€)',
    f_amount_taxes:      'Taxes (€)',
    f_amount_excl:       'Total excl. VAT (€)',
    f_vat:               'VAT (€)',
    f_amount_incl:       'Total incl. VAT (€)',
    f_notes:             'Notes',
    save_invoice:        'Save invoice',

    lines_title:   'Breakdown',
    lines_hint:    'Each line of the invoice. The total excl. VAT is computed automatically from the amounts.',
    line_add:      'Add line',
    col_group:     'Group',
    col_desc:      'Description',
    col_qty:       'Quantity',
    col_price:     'Unit price',
    col_amount:    'Amount (€)',
    group_afname:        'Consumption',
    group_injectie:      'Injection',
    group_groene_stroom: 'Green power',
    group_wkk:           'CHP',
    group_netwerk:       'Network',
    group_toeslagen:     'Levies',
    group_andere:        'Other',

    user_new:          'New user',
    user_name:         'Name',
    user_email:        'Email',
    user_role:         'Role',
    user_active:       'Active',
    user_inactive:     'Inactive',
    user_password:     'Password',
    user_password_hint:'leave empty to keep unchanged',
    role_admin:        'Administrator',
    role_viewer:       'Viewer',

    analytics_title:   'Analytics',
    an_consumption:    'Consumption',
    an_costs:          'Costs (energy / network / taxes)',
    an_unit_price:     'Unit price',
    an_comparison:     'Year comparison',
    an_components:     'Cost per component',
    an_unit_detail:    'Unit price peak / off-peak',
    an_injection:      'Consumption vs injection',
    metric_kwh:        'Consumption (kWh)',
    metric_eur:        'Amount (€)',
  },
};

export default translations;
